import { AppConfig } from './app-config.model';

export const env: AppConfig = {
    tradgineDataUrl: 'https://data.tradgine.com',
    environment: 'Development',
};
